import dotenv from "dotenv";
dotenv.config();

//
// General config
// ------------------------------------------------------------------

export const APP_NAME = process.env.APP_NAME;
export const REACT_APP_ENV_TYPE = process.env.REACT_APP_ENV_TYPE;

const minuteToSeconds = (minutes) => minutes * 60;

export const SESSION_EXPIRE_TIME_IN_SECONDS = process.env.SESSION_EXPIRE_TIME_IN_MINUTES
  ? minuteToSeconds(+process.env.SESSION_EXPIRE_TIME_IN_MINUTES)
  : minuteToSeconds(60 * 24 * 14); // 14 days in seconds



// Development environment config
// ------------------------------------------------------------------

export const DEBUG = process.env.DEBUG === "true" || false;
export const SKIP_AWS_INITIALIZATION = process.env.SKIP_AWS_INITIALIZATION === "true";

//
// Server config
// ------------------------------------------------------------------

export const PORT = process.env.PORT;

//
// Datanase config
// ------------------------------------------------------------------

export const DATABASE_URL = process.env.DATABASE_URL;

///
// Test users (these external emails are allow to access hub)
// ------------------------------------------------------------------

export const TEST_USERS = process.env.REACT_APP_TEST_USERS;
export const IN_MAINTENANCE = process.env.IN_MAINTENANCE === 'true';

//
// Google auth config
// ------------------------------------------------------------------

export const GOOGLE_CLIENT_ID = process.env.GOOGLE_CLIENT_ID;
export const GOOGLE_CLIENT_SECRET = process.env.GOOGLE_CLIENT_SECRET;
export const GOOGLE_CLIENT_EMAIL = process.env.GOOGLE_CLIENT_EMAIL; 
export const GOOGLE_CLIENT_EMAIL_PASSWORD =
  process.env.GOOGLE_CLIENT_EMAIL_PASSWORD;
export const GOOGLE_AUTH_CALLBACK_URL = process.env.GOOGLE_AUTH_CALLBACK_URL;
export const GOOGLE_AUTH_SUCCESS_REDIRECT = "/hub";
export const GOOGLE_AUTH_FAILURE_REDIRECT = "/login-failure";
export const SESSION_COOKIE_SECRET = "nine-publishing-prez-hub-cookie";

//
// Local dummy auth config
// ------------------------------------------------------------------

export const LOCAL_DEV_ENVIRONMENT =
  process.env.LOCAL_DEV_ENVIRONMENT !== undefined
    ? process.env.LOCAL_DEV_ENVIRONMENT === "true"
    : undefined;
export const LOCAL_DUMMY_AUTH_NAME = process.env.LOCAL_DUMMY_AUTH_NAME;
export const LOCAL_DUMMY_AUTH_EMAIL = process.env.LOCAL_DUMMY_AUTH_EMAIL;
export const LOCAL_DUMMY_AUTH_ID = process.env.LOCAL_DUMMY_AUTH_ID;
export const LOCAL_DUMMY_AUTH_IMAGE = process.env.LOCAL_DUMMY_AUTH_IMAGE;
export const LOCAL_DUMMY_AUTH_ACCESS_TOKEN =
  process.env.LOCAL_DUMMY_AUTH_ACCESS_TOKEN;
export const LOCAL_DUMMY_AUTH_GROUP = process.env.LOCAL_DUMMY_AUTH_GROUP;


// UPSTASH_REDIS_URL 
export const UPSTASH_REDIS_URL = process.env.UPSTASH_REDIS_URL;

//
// Local front-end development environment variables
// ------------------------------------------------------------------

// These two config variables are included to make your life easier, when you're developing locally.
// To do a "fully-fledged" test with server and front-end aspects of the application running, you
// need to run both `yarn dev:client` and `yarn dev:server`.
//
// However, this is kind of a pain, as every change you make to the code requires a full rebuild
// of the application to be rendered, breaking CRA's development server and destroying productivity.
//
// What these config variables allow you to do is bypass the login screen - it ensures you're logged
// in as the user below - and so do the vast majority of your development work using the standard
// `yarn start` create-react-app development server, with all it's hot-module-reloading goodness.

export const LOCAL_FE_DEV_ENVIRONMENT =
  LOCAL_DEV_ENVIRONMENT !== undefined ||
    LOCAL_DEV_ENVIRONMENT === false ||
    (typeof window !== "undefined" &&
      window.origin.indexOf("localhost:4000") === -1)
    ? false
    : true;



export const CRYPTO_IV = process.env.CRYPTO_IV || '';
export const CRYPTO_KEY = process.env.CRYPTO_KEY || '';


// export const _LOCAL_FE_DEV_USER = LOCAL_FE_DEV_ENVIRONMENT
//   ? {
//     email: process.env.REACT_APP_LOCAL_DEV_EMAIL
//       ? process.env.REACT_APP_LOCAL_DEV_EMAIL
//       : "sorenfrederiksen@fairfaxmedia.com.au",
//     id: "1",
//     image: process.env.REACT_APP_LOCAL_DEV_IMAGE
//       ? process.env.REACT_APP_LOCAL_DEV_IMAGE
//       : "https://lh5.googleusercontent.com/-TVlUfW4EG28/AAAAAAAAAAI/AAAAAAAAAIw/cFml0Yhy_-A/photo.jpg",
//     group: process.env.REACT_APP_LOCAL_DEV_GROUP
//       ? process.env.REACT_APP_LOCAL_DEV_GROUP
//       : "admin_user",
//     name: process.env.REACT_APP_LOCAL_DEV_NAME
//       ? process.env.REACT_APP_LOCAL_DEV_NAME
//       : "Soren Frederiksen",
//     token: "aaa"
//   }
//   : undefined;

//
// AWS config
// ------------------------------------------------------------------

export const AWS_BUCKET_URL_ROOT = process.env.AWS_BUCKET_URL_ROOT;
export const AWS_ACCESS_ID = process.env.AWS_ACCESS_ID;
export const AWS_BUCKET_NAME = process.env.AWS_BUCKET_NAME;
export const AWS_SECRET_KEY = process.env.AWS_SECRET_KEY;
export const AWS_REGION = process.env.AWS_REGION;

export const AWS_MAX_FILE_UPLOAD_SIZE_IN_MB =
  process.env.AWS_MAX_FILE_UPLOAD_SIZE_IN_MB === undefined
    ? 5
    : +process.env.AWS_MAX_FILE_UPLOAD_SIZE_IN_MB;

//
// AWS interactives config
// ------------------------------------------------------------------

export const AWS_INTERACTIVES_ACCESS_ID =
  process.env.AWS_INTERACTIVES_ACCESS_ID;
export const AWS_INTERACTIVES_BUCKET_NAME =
  process.env.AWS_INTERACTIVES_BUCKET_NAME;
export const AWS_INTERACTIVES_SECRET_KEY =
  process.env.AWS_INTERACTIVES_SECRET_KEY;
export const AWS_INTERACTIVES_REGION =
  process.env.AWS_INTERACTIVES_REGION;



export default {
  APP_NAME,
  AWS_ACCESS_ID,
  AWS_BUCKET_NAME,
  AWS_BUCKET_URL_ROOT,
  AWS_MAX_FILE_UPLOAD_SIZE_IN_MB,
  AWS_SECRET_KEY,
  AWS_REGION,
  AWS_INTERACTIVES_ACCESS_ID,
  AWS_INTERACTIVES_BUCKET_NAME,
  AWS_INTERACTIVES_SECRET_KEY,
  AWS_INTERACTIVES_REGION,
  CRYPTO_IV,
  CRYPTO_KEY,
  DATABASE_URL,
  DEBUG,
  GOOGLE_CLIENT_ID,
  GOOGLE_CLIENT_SECRET,
  GOOGLE_AUTH_CALLBACK_URL,
  GOOGLE_AUTH_SUCCESS_REDIRECT,
  GOOGLE_AUTH_FAILURE_REDIRECT,
  LOCAL_DEV_ENVIRONMENT,
  LOCAL_DUMMY_AUTH_NAME,
  LOCAL_DUMMY_AUTH_EMAIL,
  LOCAL_DUMMY_AUTH_ID,
  LOCAL_DUMMY_AUTH_IMAGE,
  LOCAL_DUMMY_AUTH_ACCESS_TOKEN,
  LOCAL_DUMMY_AUTH_GROUP,
  LOCAL_FE_DEV_ENVIRONMENT,
  // LOCAL_FE_DEV_USER,
  PORT,
  SESSION_COOKIE_SECRET,
  REACT_APP_ENV_TYPE,
  SESSION_EXPIRE_TIME_IN_SECONDS,
  SKIP_AWS_INITIALIZATION,
  TEST_USERS,
  IN_MAINTENANCE,
  UPSTASH_REDIS_URL
};